import { Navigate, useLocation } from 'react-router-dom';

const SuperAdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('superAdminToken');

  if (!token) {
    return <Navigate to="/super-admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default SuperAdminProtectedRoute;
